type CleanupFn = () => void;

const BLOCKED_KEYS = {
  F11: 122,
  F12: 123,
  F1: 112,
  I: 73,
  J: 74,
  C: 67,
  U: 85,
  S: 83,
  P: 80,
  K: 75,
  E: 69,
  M: 77,
} as const;

function blockKeyboardShortcuts(event: KeyboardEvent): void {
  const key = event.keyCode || event.which;

  // F-keys blocker
  if (key === BLOCKED_KEYS.F11 || key === BLOCKED_KEYS.F12 || key === BLOCKED_KEYS.F1) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  // Ctrl/Cmd + Shift + Key combinations (Windows/Linux/Mac)
  if ((event.ctrlKey || event.metaKey) && event.shiftKey) {
    if (
      key === BLOCKED_KEYS.I ||
      key === BLOCKED_KEYS.J ||
      key === BLOCKED_KEYS.C ||
      key === BLOCKED_KEYS.K ||
      key === BLOCKED_KEYS.E ||
      key === BLOCKED_KEYS.M
    ) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
  }

  // Mac Option + Cmd + Key combinations
  if (event.altKey && event.metaKey) {
    if (key === BLOCKED_KEYS.I || key === BLOCKED_KEYS.J || key === BLOCKED_KEYS.C) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
  }

  // Ctrl/Cmd + Key combinations
  if ((event.ctrlKey || event.metaKey) && (key === BLOCKED_KEYS.U || key === BLOCKED_KEYS.S || key === BLOCKED_KEYS.P)) {
    event.preventDefault();
    event.stopPropagation();
  }
}

function startDebuggerLoop(): number {
  return window.setInterval(() => {
    (function() { debugger; })();
  }, 50);
}

(function () {
  const element = new Image();
  Object.defineProperty(element, 'id', {
    get() {
      console.warn('DevTools açık');
    }
  });
  console.log(element);
})();

function blockContextMenu(event: MouseEvent): void {
  event.preventDefault();
}

export function startDebuggerBlocker(): CleanupFn {
  document.addEventListener('keydown', blockKeyboardShortcuts, true);
  document.addEventListener('contextmenu', blockContextMenu, true);

  const debuggerIntervalId = startDebuggerLoop();

  return () => {
    document.removeEventListener('keydown', blockKeyboardShortcuts, true);
    document.removeEventListener('contextmenu', blockContextMenu, true);
    clearInterval(debuggerIntervalId);

    const securityStyle = document.getElementById('security-styles');
    if (securityStyle) {
      securityStyle.remove();
    }
  };
}
